import createModel, { prop } from './lib/create_model';

const FbPageAccountContent = createModel({
  modelName: 'FbPageAccountContent',
  properties: {
    id: prop(String).isRequired,
    isTemporaryToken: Boolean,
    name: String,
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export default FbPageAccountContent;



// WEBPACK FOOTER //
// ./src/scripts/domain/models/fb_page_account_content.js